module.exports = __webpack_public_path__ + "static/media/blueTickk.f8889f51.svg";